import { useMemo, useState } from 'react';

import { documentoDoTitular } from '@/modulos/operacao/titulares/contrato';
import { useTitulares } from '@/modulos/operacao/titulares/dados';
import { SearchableSelect } from '@/ui/base/searchable-select';

interface TitularComboboxProps {
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/**
 * Busca de titular (proprietário do veículo) por nome ou CPF/CNPJ, server-side.
 *
 * Reaproveita `useTitulares`, a MESMA consulta de leitura da listagem — titulares
 * não têm cadastro manual (`titulares/dados.ts`), só esta busca de vínculo.
 */
export function TitularCombobox({ value, onChange, disabled, ariaLabel }: TitularComboboxProps) {
  const [busca, setBusca] = useState('');

  const filtro = useMemo(() => ({ pagina: 1, tamanho: 20, busca: busca || undefined }), [busca]);

  const { data, isLoading } = useTitulares(filtro);

  const opcoes = useMemo(
    () =>
      (data?.itens ?? []).map((titular) => ({
        value: titular.id,
        label: titular.nome,
        description: documentoDoTitular(titular) ?? undefined,
      })),
    [data?.itens],
  );

  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={opcoes}
      onSearchChange={setBusca}
      loading={isLoading}
      disabled={disabled}
      placeholder="Nenhum titular"
      searchPlaceholder="Buscar por nome ou CPF/CNPJ…"
      emptyMessage="Nenhum titular encontrado."
      ariaLabel={ariaLabel ?? 'Titular do veículo'}
    />
  );
}
